import React from 'react'

const VideoSeeAllSkeleton = () => {

    const arr = Array.from({ length: 14 });

    return (
        <div className='grid w-[98%] grid-cols-2 gap-4 mt-4 mb-5 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7 max-sm:w-full max-sm:gap-4'>
            {arr.map((_, i: number) => (
                <div
                    key={i}
                    className='mt-4 mb-5 h-[400px] max-sm:mt-0 max-sm:mb-0 bg-[#1a1919] animate-pulse rounded'
                ></div>
            ))}
        </div>
    )
}

export default VideoSeeAllSkeleton
